export function getTarget(link) {
  if (link.includes('homedepot.com')) {
    return '_self';
  }
  return '_blank';
}